import React from "react";
import "./OfflinePage.css";

const OfflinePage = () => {
  const handleRetry = () => {
    if (navigator.onLine) {
      // Go back to previous page if online
      window.history.back();
    } else {
      // Still offline, show alert or keep user here
      alert("You are still offline. Please check your internet connection.");
    }
  };

  return (
    <div className="offline-container">
      <div>
        <img
          style={{
            width: "100%",
            height: "300px",
            objectFit: "contain",
            mixBlendMode: "darken",
          }}
          src="/logo/ofline.png"
          alt="Offline"
        />
      </div>
      <h1 className="offline-title">You're Offline</h1>
      <p className="offline-message">
        No internet connection. Please check your network and try again.
      </p>
      <button className="retry-button" onClick={handleRetry}>
        Retry
      </button>
    </div>
  );
};

export default OfflinePage;
